import React, { useEffect, useRef } from 'react';

import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';

import StepperSubHeader from '../../../../../../components/Header/StepperSubHeader.component';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import { useAuthDataContext } from '../../../../../../context/auth/auth.provider';
import { useSidebarContext } from '../../../../../../context/sidebar/sidebar.provider';

const InitInspection = () => {
  const { user } = useAuthDataContext();
  const { loading, step, goBack, STEPS } = useSinisterInspectionsContext();
  const { setStepperTitle, setStep } = useSidebarContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setStepperTitle([...STEPS.current][step].title);
    setStep(step)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>

      <StepperSubHeader
        goBack={goBack}
        step={step}
        totalSteps={[...STEPS.current].length}
        //closeAction={resetSinister}
      ></StepperSubHeader>

      <Grid
        container
        justify={step === 4 ? 'flex-end' : 'center'}
        style={{ height: 'calc(100% - 4px)' }}
      >
        <Grid
          item
          xs={step === 3 ? 12 : 11}
          md={step === 3 ? 12 : 11}
          lg={step === 3 ? 12 : 11}
          xl={step === 3 ? 12 : 11}
        >
          <Grid
            container
            style={{
              height: '100%',
              paddingBottom: matches ? 'calc(94px + 24px)' : '',
            }}
          >
            <Grid item xs={12}>
              {[...STEPS.current][step].content ||
                [...STEPS.current][[...STEPS.current].length - 1].content}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InitInspection;
